import VueRouter from "vue-router";
import { GA_TRACKING_ID } from "./globals";
const global: any = window;
const ga = global.ga;
import { sleep } from "./lib/utils";
import store from "./store";

export default () => {
  if (GA_TRACKING_ID) {
    ga("create", {
      trackingId: GA_TRACKING_ID,
      cookieDomain: "auto",
      // name: "myTracker",
      // userId: "12345",
    });
  }
};

const AFTER_ROUTE_DELAY_TIME = 1000;

export const gaRouterHook = (router: VueRouter) => {
  router.afterEach(async (to, from) => {
    if (!GA_TRACKING_ID) {
      return;
    }

    await sleep(AFTER_ROUTE_DELAY_TIME);

    const page = to.path;
    const title = store.state.title;

    // console.log("gaNavigationGuard", { page, title });

    ga("send", {
      hitType: "pageview",
      page,
      title,
    });
  });
};

export const trackException = (error: Error) => {
  console.log("Error tracking ", error.message, error);
  ga("send", "exception", {
    exDescription: error.message,
    exFatal: false,
  });
};

window.addEventListener("error", (event) => {
  trackException(event.error);
});
